import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { modal } from '../../modal/ModalEmitter';

class ChatMessage extends PureComponent {
  constructor(props) {
    super(props);

    this.handleMessageChange = this.handleMessageChange.bind(this);
    this.handleMessageSubmit = this.handleMessageSubmit.bind(this);
    this.handleSendImage = this.handleSendImage.bind(this);
    this.handleOnKeyUp = this.handleOnKeyUp.bind(this);

    this.state = {
      message: '',
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setFocus();
    }, 10);
  }

  /**
   * Set the focus on the input.
   * @return
   */
  setFocus() {
    this.messageInput.focus();
  }

  /**
   * Keypress handler. ESC will close the ChatWindow.
   * @return
   */
  handleOnKeyUp(event) {
    if (event.key === 'Escape') {
      this.props.close();
    }
  }

  /**
   * Submit handler for ChatMessage
   * @param {Object} event
   * @return
   */
  handleMessageSubmit(event) {
    event.preventDefault();

    // Ignore submit if no message was entered
    if (!this.state.message) {
      return;
    }

    this.props.sendMessage(this.state.message);
    this.setState({ message: '' });
  }

  /**
   * Change handler for ChatMessage input.
   * @param {Object} event
   * @return
   */
  handleMessageChange(event) {
    const message = event.target.value;
    this.setState({ message });
  }

  /**
   * Send image handler
   * @param {Object} event
   * @return
   */
  handleSendImage() {
    modal.open('uploadImage', {
      callback: (files) => {
        const url = files[0].url;
        this.props.sendMessage(url);
      },
    });
  }

  render() {
    return (
      <div className="message">
        <form onSubmit={this.handleMessageSubmit}>
          <input
            type="text"
            placeholder="Send a message"
            ref={(input) => { this.messageInput = input; }}
            onChange={this.handleMessageChange}
            onKeyUp={this.handleOnKeyUp}
            value={this.state.message}
          />
        </form>
        <div className="upload-image" title="Send Image" onClick={this.handleSendImage}>
          <i className="zmdi zmdi-image-o" />
        </div>
      </div>
    );
  }
}

ChatMessage.propTypes = {
  close: PropTypes.func,
  sendMessage: PropTypes.func,
};

export default ChatMessage;
